import axios from 'utils/axios';

const postChangePassword = (valuesPassword, userId) => {
  return axios.patch(`/users/${userId}/changePassword`, valuesPassword);
}

export default {
  postChangePassword
}
